import {createTheme} from "@mui/material";

export const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#141624',
        },
        secondary: {
            main: '#4A7DFF',
        },
        background: {
            default: '#0E0F18',
            paper: '#141624',
        },
        text: {
            primary: '#fff',
            secondary: '#fff',
        },
        action: {
            selected: '#fff'
        }
    },
    shape: {
        borderRadius: 4,
    },
    props: {
        MuiButton: {
            size: 'small',
        },
        MuiButtonGroup: {
            size: 'small',
        },
        MuiCheckbox: {
            size: 'small',
        },
        MuiFab: {
            size: 'small',
        },
        MuiFormControl: {
            margin: 'dense',
            size: 'small',
        },
        MuiFormHelperText: {
            margin: 'dense',
        },
        MuiIconButton: {
            size: 'small',
        },
        MuiInputBase: {
            margin: 'dense',
        },
        MuiInputLabel: {
            margin: 'dense',
        },
        MuiRadio: {
            size: 'small',
        },
        MuiSwitch: {
            size: 'small',
        },
        MuiTextField: {
            margin: 'dense',
            size: 'small',
        },
        MuiList: {
            dense: true,
        },
        MuiMenuItem: {
            dense: true,
        },
        MuiTable: {
            size: 'small',
        },
    },
    typography: {
        "fontFamily": `'IBM Plex Mono', monospace`,
    },
    components: {
        MuiSpeedDial: {
            styleOverrides: {
                root: {
                    alignItems: 'flex-end'
                }
            },
        },
        MuiSpeedDialAction: {
            styleOverrides: {
                staticTooltip: {
                    justifyContent: 'flex-end'
                },
                staticTooltipLabel: {
                    position: 'static'
                }
            }
        }
    }
});